import {organization_user_status} from "@/models/organization-user.model.ts";
import type { MembershipRole } from "@shyne/shared/api";

export const USER_STATUSES = [
  {
    label: "Active",
    value: organization_user_status.active,
  },
  {
    label: "Invited",
    value: organization_user_status.invited,
  },
  {
    label: "Pending Approval",
    value: organization_user_status.pending,
  },
  {
    label: "Suspended",
    value: organization_user_status.suspended,
  },
];

export interface InvitePayload {
  name: string;
  email: string;
  role: MembershipRole;
}
